import request from '@/utils/request'

export function getClassification (data) {
  return request({
    url: 'classification',
    method: 'get',
    params: data
  })
}